import { useStaticQuery, graphql } from "gatsby";
import _ from "lodash"

export const getPriceStr = ( price ) => {
  let priceStr = '';
  if (price.min && price.max) {
      priceStr = " between " + `£` + addCommas(price.min) + " and " + `£` + addCommas(price.max);
  } else if (price.max) {
      priceStr = " under " + `£` + addCommas(price.max);
  } else if (price.min) {
      priceStr = " over " + `£` + addCommas(price.min);
  }
  return priceStr;
}

function addCommas(num) {
  // console.log('num : ' + num);
  var str = num.toString().split('.');
  // console.log('str, ' + str);
  if (str[0].length >= 4) {
      // add comma every 3 digits before decimal
      str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
  }
  /* Optional formating for decimal places
  if (str[1] && str[1].length >= 4) {
      // add space every 3 digits after decimal
      str[1] = str[1].replace(/(\d{3})/g, '$1 ');
  }*/
  return str.join('.');
}

export const ACTION_TYPES = {
  sales: " for sale in ",
  lettings: " to rent in ",
}

export const ACTION_DESC_TYPES = {
  sales: " for sale ",
  lettings: " to rent ",
}

export const pTypeBase = {
  sales: "/property/for-sale/",
  lettings: "/property/to-rent/",
}

export const toTitleCase = (text) => {
  let _text = text || '';
  // console.log('_text : ' + _text);
  if ( _text ) {
    _text = _text.trim().split(' ');
    // console.log('_text.length : ' + _text.length);
    if ( _text.length > 0 ) {
      _text = _text.map(w => w[0].toUpperCase() + w.substr(1).toLowerCase()).join(' ');
    }
  }
  return _text;
}

// TODO: hard coded details to be removed/replaced with common variables
export const parseSearchUrl = (pType, location) => {
  if (location) {
      var query = '';
      let pathUri_main = location.split(pTypeBase[pType].slice(0, -1))
      var areaVal = ''
      var bedVal = ''
      var minpriceVal = ''
      var maxpriceVal = ''
      var typeVal = ''
      var mustIncludeVal = ''
      if( pathUri_main[0] ) { // following could be regexp
        let pathUri = pathUri_main[0].split('/');
        
        //lets loop
        for(let vi = 1; vi <= pathUri.length; vi++ ) {
          // check for area
          if( typeof pathUri[vi] === "undefined" ) {continue;}
          // for-sale
          if ( pathUri[vi].indexOf("property-for-sale") >= 0 ) {
            // its area
            pType = 'sales';
          }
          if ( pathUri[vi].indexOf("property-to-rent") >= 0 ) {
            // its area
            pType = 'lettings';
          }
          if ( pathUri[vi].indexOf("in-") == 0 ) {
            // its area
            areaVal = pathUri[vi].replace("in-","").replace("-"," ");
          }
          if ( pathUri[vi].indexOf("-and-more-") >= 0 ) {
            // its bedrooms
            bedVal = pathUri[vi].replace("-and-more-bedrooms","")
          }
          if ( pathUri[vi].indexOf("studio") >= 0 ) {
            // its studio bedroom
            bedVal = 0
          }
          if ( pathUri[vi].indexOf("between-") >= 0 || 
               pathUri[vi].indexOf("over-") >= 0 || 
               pathUri[vi].indexOf("under-") >= 0
             ) {
            // its price
            let priceFilt1 = pathUri[vi].split('over-');
            if( priceFilt1[1] ) {
              minpriceVal = priceFilt1[1]
            }
            let priceFilt2 = pathUri[vi].split('under-');
            if( priceFilt2[1] ) {
              maxpriceVal = priceFilt2[1]
            }
            let priceFilt3 = pathUri[vi].split('between-');
            if( priceFilt3[1] ) {
              let priceFilt4 = priceFilt3[1].split('-and-');
              minpriceVal = priceFilt4[0]
              maxpriceVal = priceFilt4[1]
            }
          }
          // Must Include
          if (pathUri[vi].indexOf("with-") >= 0) {
            var mustIncludeArrfilt = pathUri[vi].replace("with-", "")
            mustIncludeVal = mustIncludeArrfilt.split("-and-")
          }
          let priceFilt5 = pathUri[vi].split('type-');
          if( priceFilt5[1] ) {
            typeVal = priceFilt5[1]
          }
        }
      }

    // If no area send default to set default loaction
    // We could send defaut location
    if (!areaVal || areaVal === 'undefined') {
        areaVal = "London"; // TODO
    }

    var areaAlias = areaVal.replace(' ', '-');

    return {
      pType: pType,
      areas: areaVal,
      areas_alias: areaAlias,
      bedrooms: bedVal,
      type: typeVal,
      mustInclude: mustIncludeVal,
      price: {
        min: minpriceVal,
        max: maxpriceVal,
      },
      extra: {
        bedPlus: false,
        areasTitleCase: true
      }
    }
  }
}

// TODO: hard coded details to be removed/replaced with common variables
export const savedSearchParams = (params) => {
  const {areas, bedrooms, pType, type, price, mustInclude} = params;

  return {
    department: "residential",
    searchType: pType,
    areas: areas,
    bedroom: bedrooms,
    minPrice:  price.min,
    maxPrice:  price.max,
    building: type,
    must_Include: mustInclude,
  }
}


// TODO: hard coded details to be removed/replaced with common variables
const capitalize = (s) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}

export const propertyH1 = (params) => {
  // console.log('params : ' + params);

  const {areas, bedrooms, pType, type, price, extra, mustInclude} = params;
  // console.log('areas : ' + areas);

  let h1 = "";
  let building = "";

  if ('Commercial' === pType) { // TODO
    // Commercial Property [action] in [default search area] for Sale and Rent
    building = "Commercial ";

    if (type)
      building += ` ${type} `;
    else
      building += ` Property `;

    h1 += `${building} in `;

    if (areas) {
      h1 += areas;
    }

    h1 += ` for sale and rent`;

  } else {
    let building = "Property";
    if (bedrooms)
      building = "property";

    if (bedrooms) {
      let bedPlus = extra.bedPlus ? '+' : '+';
      h1 += bedrooms + bedPlus + " Bedroom ";
    }

    if (type) {
      building = ` ${type} `;
    } else {
      building = ` Property `;
    }

    h1 += toTitleCase(building);
    h1 += ACTION_TYPES[pType];

    if (areas) {
      let _areas = areas;
      _areas = _areas.replace("-"," ");
      _areas = decodeURIComponent(_areas);
      _areas = extra.areasTitleCase ? toTitleCase(_areas) : _areas;
      h1 += _areas.replace("north","North").replace("road","Road")
    }

    if ( price && (price.min || price.max) )  {
      h1 += getPriceStr(price);
    }

    if ( mustInclude && mustInclude ) {
      h1 += " with "+mustInclude.join('-and-')
    }
  }

  // console.log("H1 title => ", h1);
  return h1;
}

export function joinUrl(...parts) {
  return parts
    .filter(Boolean)
    .map(p => p.replace(/^\/+|\/+$/g, "")) // trim leading/trailing slashes
    .join("/");
}

export const getBrandUrl = (id) => {
  const map = {
    cw: "https://www.cubittandwest.co.uk/",
    da: "https://www.douglasallen.co.uk/",
    pt: "https://www.pittis.co.uk/",
    wk: "https://www.wardsofkent.co.uk/",
    ae: "https://www.arunestates.co.uk/",
  };
   const defaultUrl = map["cw"];
  return map[id?.toLowerCase()] || defaultUrl;
};

export const isRealName = (name = "") => {
  if (!name) return false;

  // Clean whitespace
  name = name.trim().replace(/\s+/g, " ");

  // 1️⃣ Only allow real name characters
  if (!/^[A-Za-z \-'.]+$/.test(name)) return false;

  // 2️⃣ Must contain at least one vowel (Y allowed as vowel)
  if (!/[aeiouAEIOUyY]/.test(name)) return false;

  // 3️⃣ Block 6+ consonants in a row (strong bot signal)
  if (/[bcdfghjklmnpqrstvwxyz]{6,}/i.test(name)) return false;

  // 4️⃣ Block 4+ repeated characters
  if (/(.)\1{3,}/.test(name)) return false;

  // 5️⃣ Prevent extreme alternating mixed-case patterns (bots generate this)
  if (/([A-Z][a-z]){4,}|([a-z][A-Z]){4,}/.test(name)) return false;

  // 6️⃣ Length range
  if (name.length < 2 || name.length > 60) return false;

  // 7️⃣ Block randomized uppercase/lowercase distribution (AI-like names)
  const letters = name.replace(/[^A-Za-z]/g, "");
  const upperCount = (letters.match(/[A-Z]/g) || []).length;
  const lowerCount = letters.length - upperCount;

  if (upperCount > 0 && lowerCount > 0) {
    const ratio = upperCount / letters.length;
    // If uppercase is between 30–70%, it's "random" (real names rarely fall here)
    if (ratio > 0.30 && ratio < 0.70) return false;
  }

  return true;
};